

<template>
  <div>
    <!--    Breadcrumb Section Component-->
    <breadcrumb :breadcrumb="breadcrumb"/>
    <!--    Menu Page Area Section Component-->
    <menu-page-area/>
    <!--    Delivery Section Component-->
    <delivery-area/>
    <!--    Offer Section Component-->
    <offer-area/>
  </div>
</template>
<script>
import Breadcrumb from "../components/Breadcrumb";
import MenuPageArea from "../components/MenuPageArea";
import DeliveryArea from "../components/DeliveryArea";
import OfferArea from "../components/OfferArea";

export default {
  name: 'Menu',
  components: {OfferArea, DeliveryArea, MenuPageArea, Breadcrumb},
  data() {
    return {
      breadcrumb: {
        title: 'Food Menu',
        link: 'Menu'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Menu.vue